import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import TxtBox from "components/Custom/TxtBox";
import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import SwitchBtn from "components/Custom/SwitchBtn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";

import { NOTIFY, DEFAULTS } from "common/config";
import { COLORS } from "common/colors";
import {
  ERRORS,
  SUCCESS,
  WARNINGS,
  LABELS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { ApiMasters } from "apihandlers//masters/masters";

const ApiMastersHandler = new ApiMasters();

const ExpenseTypes = (props: any) => {
  const { setDashMenu } = props;
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await ApiMastersHandler.getCharges(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCharges:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      frozen: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "name",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EXPENSE_NAME,
      width: "25%",
    },
    {
      key: "chargesCategory",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EXPENSETYPE,
      width: "30%",
    },
    {
      key: "activeStatusText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "25%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "10%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRecord = () => {
    const name = (
      document.getElementById("name") as HTMLInputElement
    ).value.trim();
    let type = document.querySelector(
      'input[name="chargesCategory"]:checked'
    ) as HTMLInputElement;
    const chargesCategory = type ? type.value : "";
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // Validations

    let errors = [];
    if (name == "") {
      errors.push({
        id: "name",
        msg:
          "<span class='bold'>" +
          LABELS.EXPENSE_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!type) {
      errors.push({
        id: "chargesCategory",
        msg:
          "<span class='bold'>" +
          LABELS.EXPENSETYPE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!active) {
      errors.push({
        id: "activeStatus",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      name,
      chargesCategory,
      activeStatus: selectBtnValue.toString(),
      isPercent: "false",
      defaultValue: "0",
      isFreight: "false",
      isBalance: "false",
    };
    setIsSubmit(true);
    ApiMastersHandler.manageCharge(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.EXPENSETYPES}</li>
        </ul>
        <h4>{TITLES.EXPENSETYPES}</h4>
        <p className="SubTitles">{SUB_TITLES.EXPENSETYPES}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.EXPENSETYPES}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.EXPENSETYPES}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.EXPENSETYPE + ": " + selectedRow.name
              : "Add New " + LABELS.EXPENSETYPE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="expenseNote">
            <h4 style={{ marginBottom: 1, marginTop: 0 }}>{"Note:"}</h4>
            <ul>
              <li>
                {<span>{"Trip: "}</span>}
                {
                  "These expenses will show in trip sheet and vehicle/driver ledger"
                }
              </li>
              <li>
                {<span>{"Non Trip: "}</span>}
                {
                  "These expense will not show in trip sheet and shows in vehicle/driver ledger"
                }
              </li>
              <li>
                {<span>{"Other: "}</span>}
                {" These expense will show only in vehicle ledger"}
              </li>
            </ul>
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.EXPENSE_NAME} {<span className="red">*</span>}
            </label>
            <TxtBox
              id={"name"}
              placeholder={LABELS.EXPENSE_NAME}
              defaultValue={selectedRow.name}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup red">
            <label>
              {LABELS.EXPENSETYPE} {<span className="red">*</span>}
            </label>
            <RadioBtn
              name={"chargesCategory"}
              row={true}
              list={[
                {
                  id: "0",
                  label: LABELS.TRIP,
                  value: "Trip",
                  checked: selectedRow.id
                    ? selectedRow.chargesCategory === "Trip"
                    : true,
                  disabled: false,
                },
                {
                  id: "1",
                  label: LABELS.NON_TRIP,
                  value: "NonTrip",
                  checked: selectedRow.id
                    ? selectedRow.chargesCategory === "NonTrip"
                    : false,
                  disabled: false,
                },
                {
                  id: "2",
                  label: LABELS.OTHER,
                  value: "Other",
                  checked: selectedRow.id
                    ? selectedRow.chargesCategory === "Other"
                    : false,
                  disabled: false,
                },
              ]}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.ACTIVE_STATUS} {<span>*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "activeYes",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "activeNo",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
                // loading={isSubmit}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRecord}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(ExpenseTypes);
